import isEmpty from 'lodash/isEmpty';

import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';

import entity from './entity';
import { setNotification } from '../../notification/actions';
import { getProfileKey } from '../../authentication/selectors';

const TYPES = {
  ...entity.getTypes(),
  GET_JOB_GROUP_FAILURE: 'jobGroup/GET_JOB_GROUP_FAILURE',
  GET_JOB_GROUP_REQUEST: 'jobGroup/GET_JOB_GROUP_REQUEST',
  GET_JOB_GROUP_SUCCESS: 'jobGroup/GET_JOB_GROUP_SUCCESS',
  CREATE_JOB_GROUP_FAILURE: 'jobGroup/CREATE_JOB_GROUP_FAILURE',
  CREATE_JOB_GROUP_REQUEST: 'jobGroup/CREATE_JOB_GROUP_REQUEST',
  CREATE_JOB_GROUP_SUCCESS: 'jobGroup/CREATE_JOB_GROUP_SUCCESS',
};

const getAllJobGroups = (options, profileKey) => async (dispatch) => {
  dispatch({ type: TYPES.GET_JOB_GROUP_REQUEST, payload: { page: options.page } });
  try {
    const response = await entity.api.getJobGroups(options, profileKey);
    const { data: { content } } = response;
    const data = content.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
    dispatch({ type: TYPES.GET_JOB_GROUP_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_JOB_GROUP_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading job groups. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading job groups.', VARIANTS.INFO));
    }
    throw error;
  }
};

const createJobGroup = options => async (dispatch, getState) => {
  dispatch({ type: TYPES.CREATE_JOB_GROUP_REQUEST });
  const profileKey = getProfileKey(getState());
  try {
    const response = await entity.api.createJobGroup(options, profileKey);
    const data = response?.data;
    dispatch({ type: TYPES.CREATE_JOB_GROUP_SUCCESS, payload: { [data.id]: data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.CREATE_JOB_GROUP_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while creating a job group. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while creating a job group.', VARIANTS.INFO));
    }
    throw error;
  }
};

const updateJobGroup = (id, data) => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_REQUEST });

  try {
    const response = await entity.api.updateJobGroups(id, data);
    const job = response?.data;
    dispatch({ type: TYPES.UPDATE_REQUEST_SUCCESS, payload: { [job.id]: job } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.UPDATE_REQUEST_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating the job group. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating the job group.', VARIANTS.INFO));
    }
    throw error;
  }
};

const getJobGroupByName = (options, profileKey) => async (dispatch) => {
  try {
    const response = await entity.api.getJobGroups(options, profileKey);
    const { data: { content } } = response;
    const data = content.find(group => group?.name === options?.name);
    return data;
  } catch (error) {
    dispatch({ type: TYPES.GET_JOB_GROUP_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading job group. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading job group.', VARIANTS.INFO));
    }
    throw error;
  }
};

export {
  TYPES,
  createJobGroup,
  updateJobGroup,
  getJobGroupByName,
  getAllJobGroups,
};

export default {
  TYPES,
  ...entity.getActions(),
  getAllJobGroups,
  createJobGroup,
  updateJobGroup,
  getJobGroupByName,
};
